import { Flex, Typography, theme } from 'antd';
import useMousePosition from '@/hooks/useMousePosition';

const MAP_TOOLTIP_MAX_WIDTH = 250;

const MapTooltipEcho = ({
  title,
  offset,
}: {
  title: string;
  offset?: { x: number; y: number };
}) => {
  const { token } = theme.useToken();
  const { x, y } = useMousePosition();

  if (!title || !x || !y) return null;

  return (
    <Flex
      data-testid="map-tooltip"
      style={{
        position: 'fixed',
        left: `${x + (offset?.x ?? 0)}px`,
        top: `${y + (offset?.y ?? 0)}px`,
        maxWidth: MAP_TOOLTIP_MAX_WIDTH,
        padding: token.paddingXS,
        borderRadius: token.borderRadiusSM,
        background: token.colorBgSpotlight,
        whiteSpace: 'normal',
        zIndex: token.zIndexPopupBase,
        pointerEvents: 'none',
      }}
    >
      <Typography.Text
        strong
        style={{ color: token.colorTextLightSolid, fontSize: token.fontSizeSM }}
      >
        {title}
      </Typography.Text>
    </Flex>
  );
};

export default MapTooltipEcho;
